import { apiGet, apiPut } from "./client";
import { buildListQuery, type CursorListParams } from "./pagination";

export interface PluginConfig {
  pluginId: string;
  name: string;
  description: string;
  enabled: boolean;
  version: string;
  installPath?: string;
}

export interface ListPluginsResponse {
  plugins: PluginConfig[];
  total?: number;
  limit?: number;
  offset?: number;
  hasMore?: boolean;
  nextCursor?: string;
}

export async function listPlugins(
  params?: CursorListParams,
): Promise<ListPluginsResponse> {
  return apiGet<ListPluginsResponse>(
    "/api/plugins",
    buildListQuery(params as Record<string, string | number | boolean | undefined | null>),
  );
}

export async function getPlugin(id: string): Promise<PluginConfig> {
  const res = await apiGet<{ plugin: PluginConfig }>(`/api/plugins/${id}`);
  return res.plugin;
}

export async function togglePlugin(id: string): Promise<PluginConfig> {
  return apiPut<PluginConfig>(`/api/plugins/${id}/toggle`);
}
